import { useEffect } from 'react';

import type { Heading } from './getHeadingList';

import AnchorLink from '@helsenorge/designsystem-react/components/AnchorLink';
import Icon, { IconSize } from '@helsenorge/designsystem-react/components/Icon';
import List from '@helsenorge/designsystem-react/components/Icons/List';

import styles from './styles.module.scss';

export interface TableOfContentsProps {
  title: string;
  headingListAriaLabel: string;
  headingList: Heading[];
}

const TableOfContents: React.FunctionComponent<TableOfContentsProps> = ({ title, headingListAriaLabel, headingList }) => {
  // Naviger til riktig overskrift ved innlasting av side med hash i URL
  useEffect(() => {
    const id = decodeURI(window.location.hash).substring(1);
    const initialHeading = headingList.find(({ slug }) => slug === id);
    if (initialHeading) {
      initialHeading.element?.scrollIntoView();
    }
  }, []);

  return (
    <nav className={styles.tableofcontents} aria-label={headingListAriaLabel}>
      <div className={styles['tableofcontents__title-container']}>
        <Icon svgIcon={List} size={IconSize.XSmall} />
        <span className={styles['tableofcontents__title']}>{title}</span>
      </div>
      <div className={styles.tableofcontents__list}>
        {headingList.map(heading => (
          <AnchorLink key={heading.slug} href={`#${heading.slug}`}>
            {heading.title}
          </AnchorLink>
        ))}
      </div>
    </nav>
  );
};

export default TableOfContents;
